import React, { useState } from "react";
import "./promopage.css";

const DocsPromoPage = () => {
  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <div
            style={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="iframe-container">
              {/* Banner visually inside the iframe area */}
              <div className="promo-banner">
                <div className="promo-text">
                  💥 Use the following discount code:{" "}
                  <strong>SLS15PROMO</strong> to get <strong>15% off</strong> on
                  all nationwide docs!
                </div>
              </div>

              {/* Embedded site */}
              <iframe
                src="https://dossdocs.com/"
                title="DOSSDOCS"
                className="docs-iframe"
              ></iframe>
            </div>
          </div>
        </article>
      </section>
    </div>
  );
};

export default DocsPromoPage;
